import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { BreadcrumbsService } from './services/breadcrumbs.service';

@NgModule({
  declarations: [],
  imports: [CommonModule, HttpClientModule],
  providers: [BreadcrumbsService]
})
export class CoreModule { }
